import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/delivery.scss";

const formatShippingPrice = (amount) => {
  if (amount === 0) return "Complimentary";
  if (typeof siteConfig.formatPrice === "function") {
    return siteConfig.formatPrice(amount);
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: siteConfig.currency || "USD",
    maximumFractionDigits: 0,
  }).format(amount);
};

const deliveryOptions = [
  {
    name: "Standard delivery",
    timing: "3-5 business days",
    fee: 9.99,
  },
];

function Delivery() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="delivery-page">
      <header className="delivery-page__hero">
        <p>Client services</p>
        <h1>Shipping and delivery</h1>
        <div>
          <p>
            Every {siteConfig.brandName} order is prepared with care and sent
            using a tracked service. Available options are confirmed at checkout.
          </p>
          <span>Hong Kong studio / international delivery</span>
        </div>
      </header>

      <div className="delivery-page__layout">
        <aside>
          <nav aria-label="On this page">
            <p>On this page</p>
            <a href="#delivery-options">Delivery options</a>
            <a href="#delivery-processing">Order processing</a>
            <a href="#delivery-tracking">Tracking</a>
            <a href="#delivery-duties">Taxes and duties</a>
            <a href="#delivery-restrictions">Restrictions</a>
          </nav>
        </aside>

        <article className="delivery-page__content">
          <section id="delivery-options" aria-labelledby="delivery-options-title">
            <p className="delivery-page__index">01</p>
            <h2 id="delivery-options-title">Delivery options</h2>
            <p>
              The delivery methods shown below apply to in-stock orders. Your
              exact delivery date and cost will be displayed before payment.
            </p>

            <div className="delivery-page__services" role="table" aria-label="Delivery options">
              <div className="delivery-page__service delivery-page__service--head" role="row">
                <span role="columnheader">Service</span>
                <span role="columnheader">Estimated arrival</span>
                <span role="columnheader">Fee</span>
              </div>
              {deliveryOptions.map((option) => (
                <div className="delivery-page__service" role="row" key={option.name}>
                  <strong role="cell">{option.name}</strong>
                  <span role="cell">{option.timing}</span>
                  <span role="cell">{formatShippingPrice(option.fee)}</span>
                </div>
              ))}
            </div>
            <small>
              Business days exclude weekends and public holidays. Remote addresses
              may require additional transit time.
            </small>
          </section>

          <section id="delivery-processing" aria-labelledby="delivery-processing-title">
            <p className="delivery-page__index">02</p>
            <h2 id="delivery-processing-title">Order processing</h2>
            <p>
              Orders are subject to payment authorization and availability. Once
              accepted, they are generally prepared within one business day.
              Orders placed after 1:00 PM local fulfillment time begin processing
              on the following business day.
            </p>
            <dl className="delivery-page__facts">
              <div>
                <dt>Order confirmation</dt>
                <dd>Sent immediately after a successful checkout.</dd>
              </div>
              <div>
                <dt>Shipping confirmation</dt>
                <dd>Sent when your parcel leaves our fulfillment partner.</dd>
              </div>
              <div>
                <dt>Multiple items</dt>
                <dd>Items may arrive separately at no additional delivery cost.</dd>
              </div>
            </dl>
          </section>

          <section id="delivery-tracking" aria-labelledby="delivery-tracking-title">
            <p className="delivery-page__index">03</p>
            <h2 id="delivery-tracking-title">Tracking your order</h2>
            <p>
              A tracking link is included in the shipping confirmation email. It
              can take up to 24 hours for the carrier to display the first scan.
              Please allow the estimated window to pass before contacting Client
              Services about a delayed parcel.
            </p>
          </section>

          <section id="delivery-duties" aria-labelledby="delivery-duties-title">
            <p className="delivery-page__index">04</p>
            <h2 id="delivery-duties-title">Taxes and duties</h2>
            <p>
              Applicable sales tax is calculated according to the delivery address
              and shown in the order summary. Any locally required taxes or duties
              are handled according to the delivery destination and applicable law.
            </p>
          </section>

          <section id="delivery-restrictions" aria-labelledby="delivery-restrictions-title">
            <p className="delivery-page__index">05</p>
            <h2 id="delivery-restrictions-title">Delivery restrictions</h2>
            <p>
              We cannot deliver to PO boxes, package forwarding services, or
              addresses outside the market selected at checkout. A signature may
              be required. Once an order has entered preparation, its delivery
              address cannot always be changed.
            </p>
          </section>

          <footer className="delivery-page__help">
            <div>
              <p>Need delivery assistance?</p>
              <h2>Our Client Services team is available to help.</h2>
            </div>
            <Link to="/contact" onClick={toTop}>
              Contact us
            </Link>
          </footer>
        </article>
      </div>
    </main>
  );
}

export default Delivery;
